<script setup>
const personArticles = inject('personArticles')
</script>

<template>
	<span v-if="!personArticles.length">
		<slot name="header" />
		<i class="text-muted">{{ $t('No articles found.') }}</i>
	</span>
	<template v-else>
		<theme-base-swiper
			v-slot="slotProps"
			tag="section"
			:title="$t('Articles')"
			title-classes="fw-bold mb-3"
			:items="personArticles"
			:columns="{
				xs: 6,
				md: 4,
			}"
			url="/nieuws"
			class="mb-5"
			inline
		>
			<theme-card-plain
				tag="article"
				:item="slotProps.item"
				style="--card-aspect-ratio: 1 / 0.75"
				class="w-100"
			>
				<template #img="{ meta }">
					<thumbor-image
						:use="['md', 'lg']"
						:dimensions="{
							md: [250, 150],
							lg: [306, 330],
						}"
						:img="meta.imgSource"
						class="w-100 mb-0"
						:classes="{
							img: 'custom-card-img image-fluid w-100',
						}"
						:crop-preset="meta.imgCropping"
					/>
				</template>
			</theme-card-plain>
		</theme-base-swiper>
	</template>
</template>
